import {categoriesActionTypes} from "../constants/ActionTypes";
import TreeHelper from "../utils/TreeHelper";

const initialState = {
  categories: [],
  categoriesList: null
};

const categories = (state = initialState, action) => {
  switch (action.type) {
    case categoriesActionTypes.GET_CATEGORIES:
      const categoriesParentsMap = {};

      action.categories.forEach((category) => {
        categoriesParentsMap[category.value] = null;
        TreeHelper.normalizeCheckboxCategoriesTree(category, categoriesParentsMap);
      });

      return {
        ...state,
        categories: action.categories,
        categoriesList: action.categoriesList,
        categoriesParentsMap: categoriesParentsMap,
        // categoriesList: TreeHelper.formatTreeToList(action.categories)
      };
  }

  return state;
};

export default categories;



// WEBPACK FOOTER //
// ./reducers/categories.reducers.js